

























































export let ixStatus = /*#__PURE__*/function (ixStatus) {ixStatus["ready"] = "ready";ixStatus["sending_labeled_data"] = "sending_labeled_data";ixStatus["processing_model"] = "processing_model";ixStatus["processing_suggestions"] = "processing_suggestions";ixStatus["cancel"] = "cancel";ixStatus["error"] = "error";return ixStatus;}({});